import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { string } from 'prop-types';
import { useSelector } from 'react-redux';
import { Loader } from '@tesla/design-system-react';
import './style.module.scss';

const lazyWithRetry = (componentImport) =>
  lazy(async () => {
    const pageHasAlreadyBeenForceRefreshed = JSON.parse(
      window.localStorage.getItem('careers-force-refresh') || 'false'
    );

    try {
      const component = await componentImport();

      window.localStorage.setItem('careers-force-refresh', 'false');

      return component;
    } catch (error) {
      // Catch chunk not loading error and force refresh the page
      if (!pageHasAlreadyBeenForceRefreshed) {
        window.localStorage.setItem('careers-force-refresh', 'true');
        return window.location.reload();
      }

      throw error;
    }
  });

const Search = lazyWithRetry(() => import('./containers/Search'));
const JobDetails = lazyWithRetry(() => import('./containers/JobDetails'));
const JobApplication = lazyWithRetry(() => import('./containers/JobApplication'));

const Router = ({ baseRoute }) => {
  const isVersion2 = useSelector((state) => state.app.isVersion2);
  const supportsHistory = 'pushState' in window.history;

  return (
    <BrowserRouter basename={baseRoute} forceRefresh={!supportsHistory}>
      <Suspense fallback={<Loader show="true" />}>
        <Routes>
          <Route exact path="/" element={<Search />} />
          <Route exact path="/job/:slug" element={<JobDetails />} />
          {isVersion2 && <Route exact path="/job/apply/:jobId" element={<JobApplication />} />}
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

Router.propTypes = {
  baseRoute: string.isRequired,
};

export default Router;
